import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../../common/template/content';
import Tabs from '../../common/tab/tabs';
import TabsHeader from '../../common/tab/tabsHeader';
import TabsContent from '../../common/tab/tabsContent';
import TabHeader from '../../common/tab/tabHeader';
import TabContent from '../../common/tab/tabContent';
import PermissaoUsuario from '../../auth/permissao';
import { init, create, update } from './equipeActions';

import List from './equipeList';
import Form from './equipeForm';
import Membros from './equipeMembros';

class Equipe extends Component {
  componentWillMount() {
    this.props.init();
  }

  render() {
    return (
      <div>
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadManutencaoEquipe" campo="incluir" condicao={true}>
                <TabHeader label="Incluir" icon="plus" target="tabCreate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEquipe" campo="alterar" condicao={true}>
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEquipe" campo="membros" condicao={true}>
                <TabHeader label="Membros" icon="user-friends" target="tabMembros" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Salvar" premiumLayout />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form onSubmit={this.props.update} submitClass="primary" submitLabel="Salvar" premiumLayout />
              </TabContent>
              <TabContent id="tabMembros">
                <Membros />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ init, create, update }, dispatch);
export default connect(null, mapDispatchToProps)(Equipe);
